const Selectors = {
  classes: {
    variantButton: '.single-option-selector',
    defaultSelectorsWrapper: '.product-form__default-controls-group .selector-wrapper',
    allProductsSelectors: '.product-option__item-select',
    allPropertiesInputs: '.product-option__item-input input',
    allPropertiesInputsError: '.product-option__item-input.error',
    orderNotes: '.product-options__item-textarea textarea',
    form: 'form.product-form',
    buyNowButton: '.checkout-btn',
    productOptionItem: '.product-options__item',
    productOptionItemError: '.product-options__item.error',
    productCheckboxItemError: '.product-options__checkbox-group-wrapper.error',
    relatedProductWrapper: '.related_products_wrapper',
    relatedProductSelect: '.related_products-select',
    relatedProductCheckbox: '.related_products-checkbox input',
    relatedVariantsSelect: '.related_variants-select select',
    relatedVariantImageWrap: '.related_variants-image',
    adaptorModelSelect: '.adaptor-model-value',
    adaptorModelOption: '.adaptor-model-option',
    propertiesOptionsSelect: '.properties_options-select select',
    propertiesOptionsRadio: '.product-options__checkbox-content input',
    requiredCheckboxSelect: '.product-options__checkbox-group-wrapper input',
    multipleCheckboxSelect: '.product-group_checkbox-wrapper input',
    formProperties: '.form_selected_properties',
    submitLoadingButton: '.product-form__cart-submit',
    priceHolder: 'span[data-variant-price]',
    colorSwatch: '.color-swatch',
    clubQuantity: '.club-quantity',
    clubValue: '.club-value',
    singleProductSelect: '.single-product select',
    mainPrice: '.price-item',
    groupOfChecbxes: '.group-of-checkboxes',
  },

  relatedProductIds: [],
  relatedProductsObj: {},
  propertiesObj: { ["_main_group_key"]: Date.now() },
  clubCheckboxes: [],

  buildPropertiesObject: function (target) {
    if (target.name && target.name != "" && target.value) {
      Selectors.propertiesObj = {
        ...Selectors.propertiesObj,
        [target.name]: target.value,
      };
    }

     //console.log("properties object", Selectors.propertiesObj);
  },
  buildPropertiesInputs: function () {
    // console.log("buildPropertiesInputs", Selectors.propertiesObj);
    const formProperties = document.querySelector(this.classes.formProperties);
    const inputsArray = [];

    for (const [key, value] of Object.entries(Selectors.propertiesObj)) {
      if (key && value != null) {
        inputsArray.push(
          `<input type="hidden" name="properties[${key}]" value="${value}">`
        );
      }
    }

    formProperties.innerHTML = inputsArray.map((input) => input).join("");
  },
  buildRelatedProductIds: function () {
    Selectors.relatedProductIds = [];
    Selectors.relatedProductsObj = {};
    let price = null;

    document
      .querySelectorAll(this.classes.relatedVariantsSelect)
      .forEach((select) => {
        price = select.options[select.selectedIndex].dataset.variantPrice;
        txt = select.options[select.selectedIndex].text;

        if (!txt.includes("No ")) {
          Selectors.relatedProductIds.push(select.value);
        }
        // console.log(price);
        if (![null, undefined].includes(price)) {
          Selectors.relatedProductsObj[select.value] = price;
        }
      });
    document
      .querySelectorAll(this.classes.requiredCheckboxSelect)
      .forEach((checkbox) => {
        price = checkbox.dataset.variantPrice;
        Selectors.relatedProductIds.push(checkbox.checked.value);
        if (![null, undefined].includes(price) && checkbox.checked) {
          Selectors.relatedProductsObj[checkbox.value] = price;
        }
      });

    document
      .querySelectorAll(this.classes.relatedProductCheckbox)
      .forEach((checkbox) => {
        price = checkbox.dataset.variantPrice;
        if (![null, undefined].includes(checkbox) && checkbox.checked) {
          Selectors.relatedProductIds.push(checkbox.value);
          Selectors.relatedProductsObj[checkbox.value] = price;
        }
      });

    Selectors.relatedProductIds = Selectors.relatedProductIds.filter(
      (id) => id
    );
  },
  onRelatedVariantsChange: function () {
    document
      .querySelectorAll(this.classes.relatedVariantsSelect)
      .forEach((select) => {
        const notValidGrips = [
          "Golf Pride MCC Black White Align Standard",
          "Golf Pride MCC Black White Align Midsize",
          "Golf Pride MCC Plus 4 Gray Align Standard",
          "Golf Pride MCC Plus 4 Gray Align Midsize",
          "Golf Pride Tour Velvet Align Standard",
          "Golf Pride Tour Velvet Align Midsize",
          "Golf Pride Z-Grip Cord Align Standard",
          "Golf Pride Z -Grip Cord Align Midsize",
        ];

        select.addEventListener("change", function (e) {
          const txt = select.options[select.selectedIndex].text;
          notValidGrips.some((element) => {
            if (txt.includes(element)) {
              $('.checkbox-logo label[for="Down"]').css("display", "none");
              return true;
            }
            $('.checkbox-logo label[for="Down"]').css("display", "flex");
            return false;
          });
        });
      });
  },
  onRelatedProductChange: function () {
    
    document
      .querySelectorAll(this.classes.relatedProductSelect)
      .forEach((select) => {
        select.addEventListener("change", function (e) {
          Selectors.getRelatedProductVariants(e.target.value, e.target);
          Selectors.changePrice();
        });
      });
  },

  clearInputs: function () {
    
    setTimeout(() => {
      const elements = document.querySelectorAll(
        ".product-option__item-select"
      );

      elements.forEach((elem) => {
        for (let i = 0; i < elem.length; i++) {
          //clear if defaults present
          //elem.options[0].selected = true;
          
        }
      });
    }, 1000);
  },

  onRelatedVariantChange: function () {
    document
      .querySelectorAll(this.classes.relatedVariantsSelect)
      .forEach((select) => {
        select.addEventListener("change", function (e) {
          if (!e.target.value) return;
          Selectors.removeError(e.target);
          Selectors.showVariantImage(e.target.value, e.target);
          Selectors.buildRelatedProductIds();
          Selectors.changePrice();
        });
      });
  },
  onPropertieSelectChange: function () {
   
    document
      .querySelectorAll(this.classes.propertiesOptionsSelect)
      .forEach((select) => {
        select.addEventListener("change", function (e) {
          if (!e.target.value) return;

          Selectors.removeError(e.target);
          Selectors.buildPropertiesObject(e.target);
        });
      });
  },
  onPropertieInputChange: function(){
    document.querySelectorAll(this.classes.allPropertiesInputs).forEach(input => {

      input.addEventListener('keyup', (e) =>  removeError(e));
      input.addEventListener('mouseup', (e) =>  removeError(e));

      function removeError(e) {
        input.parentElement.classList.remove('error')
        if ( e.target.value !== '') {
          input.parentElement.classList.remove('error');
        }

        if (!e.target.value) return
        Selectors.buildPropertiesObject(e.target);
      }
    })
  },
  onPropertiesAreaChange: function () {
    document.querySelectorAll(this.classes.orderNotes).forEach((textarea) => {
      textarea.addEventListener("keyup", function (e) {
        if (!e.target.value) return;

        Selectors.buildPropertiesObject(e.target);
      });
    });
  },
  onSelectAdaptorModelChange: function () {
    $(".adaptor-settings-value").prop("disabled", true);
    $(".adaptor-settings-value").html("<option>Choose Option</option>");
    $(".adaptor-variant-mark").hide();
    $(".adaptor-model-value").change(function () {
      $(".adaptor-settings-value").html("");
      $(".adaptor-variant-help").html("");
      let newOptions = $(".adaptor-model-value :selected").data("settings");
      let helpText = $(".adaptor-model-value :selected").data("variant-help");
      if (helpText != undefined) {
        $(".adaptor-variant-mark").show();
        $(".adaptor-variant-help").append(helpText);
      } else {
        $(".adaptor-variant-mark").hide();
      }
      for (let i = 0; i < newOptions.length; i++) {
        $(".adaptor-settings-value").append(
          "<option>" + newOptions[i] + "</option>"
        );
      }
      $(".adaptor-settings-value").prop("disabled", false);
      Selectors.buildPropertiesObject($(".adaptor-settings-value")[0]);
    });
  },
  onPropertieRadioChange: function () {
    document
      .querySelectorAll(this.classes.propertiesOptionsRadio)
      .forEach((radio) => {
        radio.addEventListener("change", function (e) {
          if (!e.target.value) return;

          Selectors.removeError(e.target);
          Selectors.buildRelatedProductIds();
          Selectors.buildPropertiesObject(e.target);
        });
      });
  },
  onRequiredCheckboxChange: function () {
    document
      .querySelectorAll(this.classes.requiredCheckboxSelect)
      .forEach((radio) => {
        radio.addEventListener("change", function (e) {
          if (!e.target.value) return;

          Selectors.removeError(
            e.target,
            ".product-options__checkbox-group-wrapper"
          );
          Selectors.buildRelatedProductIds();
          Selectors.changePrice();
        });
      });
  },
  onProductCheckboxChange: function () {
    document
      .querySelectorAll(this.classes.relatedProductCheckbox)
      .forEach((radio) => {
        radio.addEventListener("change", function (e) {
          if (!e.target.value) return;

          Selectors.removeError(
            e.target,
            ".product-options__checkbox-group-wrapper"
          );
          Selectors.buildRelatedProductIds();
          Selectors.changePrice();

        });
      });
  },
  onColorsChangeSlides: function () {
    document.querySelectorAll(".color-swatch").forEach((checkbox) => {
      checkbox.addEventListener("change", function () {

        let selected_variant = $('[name="id"]').val();
        let product_slider = document.querySelectorAll('.product-slider .swiper-wrapper img')

        product_slider.forEach((slide, index) => {
          slide.dataset.variantId.split(',').forEach(item => {
            if (+item === +selected_variant) {
              document.variantImageSlider.slideTo(index, 1000, false);
            }
          })
        })
      });
    });
  },

  onMultipleCheckboxChange: function () {
    document
      .querySelectorAll(this.classes.multipleCheckboxSelect)
      .forEach((checkbox) => {
        checkbox.addEventListener("change", function (e) {
          // console.log(
          //   Selectors.clubCheckboxes.length,
          //   "Selectors.clubCheckboxes.length"
          // );
          if (e.target.checked) {
            Selectors.clubCheckboxes.push($(this).val());
          } else {
            Selectors.clubCheckboxes.splice(
              $.inArray($(this).val(), Selectors.clubCheckboxes),
              1
            );
          }

          Selectors.validGroupOfCheckboxes();
          Selectors.validGroupOfChecked();
          Selectors.changePrice();
        });
      });
  },
  calculateMultipleCheckboxes: function () {
    document
      .querySelectorAll(this.classes.multipleCheckboxSelect)
      .forEach((checkbox) => {
        if (checkbox.checked) {
          Selectors.clubCheckboxes.push($(checkbox).val());
        }
      });
  },
  getRelatedProductVariants: function (value, target) {
    if (!value) return;
 
    fetch(`/products/${value}.js`)
      .then((response) => response.json())
      .then((data) => {
        if (target) {
          Selectors.buildRelatedProductVariants(data, target);
          Selectors.removeError(target);
          Selectors.changePrice(data);
        }
      })
      .catch((error) => {
        if (target) {
          const errorMsg = `Error: ${error}`;
          Selectors.showError(target, errorMsg);
        }
      });
  },
  changePrice: function () {
    
    let price = parseInt(
      document.querySelector(this.classes.priceHolder).dataset.variantPrice
    );
    let selectedCheckboxes = 0;
    for (const [key, value] of Object.entries(Selectors.relatedProductsObj)) {
      price += parseInt(value);
    }
    document
      .querySelectorAll(this.classes.multipleCheckboxSelect)
      .forEach((checkbox) => {
        if (checkbox.checked) {
          ++selectedCheckboxes;
        }
      });

    // console.log(Selectors.relatedProductsObj);
    if (selectedCheckboxes != 0) {
     
      document.querySelector(this.classes.priceHolder).dataset.summPrices =
        price * selectedCheckboxes;
      document.querySelector(this.classes.priceHolder).innerHTML =
        Shopify.formatMoney(price * selectedCheckboxes);
    } else {
      document.querySelector(this.classes.priceHolder).dataset.summPrices =
        price;
      document.querySelector(this.classes.priceHolder).innerHTML =
        Shopify.formatMoney(price);
    }
    // console.log(selectedCheckboxes, 'selectedCheckboxes')
    if (window.breadCreateButtons) {
      window.breadCreateButtons();
    }
  },
  buildClubsCheckboxes: function () {
    const checkedCount = Selectors.clubCheckboxes.length;
    if (checkedCount <= 0) return;
    document.querySelector(this.classes.clubQuantity).value = checkedCount;
  },
  buildClubNumberValue: function () {
    const clubNumbers = Selectors.clubCheckboxes;
    const clubValueWrap = document.querySelector(this.classes.clubValue);
    if (clubValueWrap != null) {
      if (clubNumbers <= 0) {
        clubValueWrap.remove();
      } else {
        clubValueWrap.value = clubNumbers;
      }
    }
  },
  updateMainProductProperty: function (mainGroupProductKey, redirectUrl) {
    // console.log(
    //   Selectors.clubCheckboxes.length,
    //   "Selectors.clubCheckboxes.length"
    // );
    const data = {
      // properties: {
      //   ...Selectors.propertiesObj,
      //   _main_group_product: mainGroupProductKey ? mainGroupProductKey : true
      // },
      id: document.querySelector(".product-form__variants").value,
      quantity:
        Selectors.clubCheckboxes.length == 0
          ? $('.quantity-item input[name="quantity"]').val()
          : Selectors.clubCheckboxes.length,
    };

    fetch(`/cart/change.js`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then(() => {
        Selectors.loading(false);
        window.location.href = redirectUrl;
      })
      .catch((error) => {
        Selectors.loading(false);
        // console.log("error", error);
        // if(target){
        //   const errorMsg = `Error: ${error}`;
        //   Selectors.showError(target, errorMsg);
        // }
      });
  },
  buildRelatedProductVariants: function (product, target) {
    if (!product) return;
    const variants = product.variants;
    let firstVariant = null;

    if (variants.length > 0) {
      firstVariant = variants[0].id;
      const parent = target.closest(this.classes.relatedProductWrapper);
      const select = parent.querySelector(this.classes.relatedVariantsSelect);
      select.innerHTML = "";
      var isCounterbalance = $('.isCounterbalance').is(":checked");

      const options = variants
        .map((variant) => {
         if (isCounterbalance == true){
           /*Counterbalance option is selected so only output 17inch Superstroke Grip and stock shaft*/
           if (variant.id == '42506287612090' || variant.id == '41346802188474' || variant.id == '42612785119418' || variant.id == '42612785152186'){
               return `<option class="product-variant" data-variant-price="${
               variant.price
              }" value="${variant.id}" data-putterbuild="Counterbalance">
              ${variant.title} (+${Shopify && Shopify.formatMoney(variant.price)})
              </option>`;
             } else {
              return `<option class="product-variant" data-variant-price="${
               variant.price
              }" value="${variant.id}">
              ${variant.title} (+${Shopify && Shopify.formatMoney(variant.price)})
              </option>`;
             }
           
          } else {
           /*else return all products as normal but if putter add counterbalance data attribute to counterbalance grip*/
          
           if (product.type == "Putter Shaft Dropdowns" && variant.id == '41346802188474'){
              return `<option class="product-variant" data-variant-price="${
               variant.price
              }" value="${variant.id}" data-putterbuild="Counterbalance">
              ${variant.title} (+${Shopify && Shopify.formatMoney(variant.price)})
              </option>`;
           } else {
             return `<option class="product-variant" data-variant-price="${
               variant.price
              }" value="${variant.id}">
              ${variant.title} (+${Shopify && Shopify.formatMoney(variant.price)})
              </option>`;
           }

           
         }
          
        })
        .join("");
      select.innerHTML = options;
      select.removeAttribute("disabled");
      if (isCounterbalance == true && product.type == "Putter Grip Dropdowns"){
      select.value = '42612785119418';
      $(".gripModel option").not('[data-putterbuild]').wrap('<span>');
    } else if (isCounterbalance == true && product.type == "Putter Shaft Dropdowns"){
     select.value = '41346802188474';   
      } else {
        select.value = firstVariant;
    }
      select.dispatchEvent(new Event("change"));
    }
  },
  showVariantImage: function (variant, target) {
   //(".variant-img").hide();
    const parent = target.closest(this.classes.relatedProductWrapper);
    if (!parent) return;
    const variantImagesWrap = parent.querySelector(
      this.classes.relatedVariantImageWrap
    );
    const variantImages = variantImagesWrap.querySelectorAll("img.variant-img");

    variantImages.forEach((image) => {
      
      if (image.dataset.variantId !== variant) {
        image.style.display = "none";
        
      } else {
        
        image.style.display = "block";
        variantImagesWrap.querySelector("div").style.display = "none";
      }
    });
  },
  loading: function (enable) {
    const submitButton = document.querySelector(
      this.classes.submitLoadingButton
    );
    const buyNowSubmitButton = document.querySelector(
      this.classes.buyNowButton
    );

    if (!submitButton) return;

    if (enable) {
      submitButton.querySelector(".spinner").classList.remove("hide");
      submitButton.disabled = true;

      if (buyNowSubmitButton) {
        buyNowSubmitButton.querySelector(".spinner").classList.remove("hide");
        buyNowSubmitButton.disabled = true;
      }
    } else {
      submitButton.querySelector(".spinner").classList.add("hide");
      submitButton.disabled = false;

      if (buyNowSubmitButton) {
        buyNowSubmitButton.querySelector(".spinner").classList.add("hide");
        buyNowSubmitButton.disabled = false;
      }
    }
  },
  addToCartButton: function () {
    const defaultSubmitButton = document.querySelector(
      this.classes.submitLoadingButton
    );
    const buyNowSubmitButton = document.querySelector(
      this.classes.buyNowButton
    );

    document
      .querySelector(this.classes.form)
      .addEventListener("submit", function (e) {
        e.preventDefault();
      });

    defaultSubmitButton.addEventListener("click", function (e) {
      // console.log("DEFAULT BUTTON");
      Selectors.addToCart();
    });

    buyNowSubmitButton.addEventListener("click", function (e) {
      // console.log("QUICK BUY");
      Selectors.addToCart("/checkout");
    });
  },
  addToCart: function (redirectUrl = "/cart") {
    if (!Selectors.validate()) return;
    // console.log("Validation passed.");

    Selectors.buildPropertiesInputs();
    Selectors.buildClubsCheckboxes();
    Selectors.buildClubNumberValue();
    Selectors.loading(true);
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $(Selectors.classes.form).serialize(),
      // data: $(this).serialize(),
      dataType: "json",
      success: function (res) {
        const mainGroupProductKey = res.key;
        if (Selectors.relatedProductIds.length > 0) {
          Selectors.addToCartRelatedProducts(mainGroupProductKey, redirectUrl);
        } else {
          // console.log("redirect to", redirectUrl);
          window.location.href = redirectUrl;
        }
      },
      error: function (error) {
        Selectors.loading(false);
        // console.log('error', error);
        if (error?.responseJSON?.description) {
          alert(error.responseJSON.description);
          // console.log("error", error.responseJSON.description);
        }
      },
    });
  },
  addToCartRelatedProducts: function (mainGroupProductKey, redirectUrl) {
    const data = {
      items: [],
    };
    // console.log(Selectors.relatedProductIds);
    Selectors.relatedProductIds.forEach((id) => {
      const relatedProductType = document.querySelector(
        `.related_variants-select .product-option__item-select [value="${id}"]`
      );

      const sstSelect = document.querySelector(
        `.single-product [value="${id}"]`
      );

      let myPropertiesObj = {
        _additional_product: mainGroupProductKey ? mainGroupProductKey : true,
      };

      if (relatedProductType != null) {
        const Parent = relatedProductType.closest(
          ".option__wrapper__two-items"
        );

        myPropertiesObj._adstype =
          Parent != null
            ? Parent.querySelector("select[product-with-ads]").options[
              Parent.querySelector("select[product-with-ads]").selectedIndex
              ].dataset.adsType
            : "";
      }
      myPropertiesObj._main_group_key =
        Selectors.propertiesObj["_main_group_key"];

      if (sstSelect) {
        myPropertiesObj._adstype = sstSelect.dataset.adsType || "";
      }

      data.items.push({
        properties: myPropertiesObj,
        id: id,
        quantity:
          Selectors.clubCheckboxes.length == 0
            ? $('.quantity-item input[name="quantity"]').val()
            : Selectors.clubCheckboxes.length,
      });
    });

    if (!Selectors.validate()) return;
    // console.log("Validation passed.");
    Selectors.loading(true);
    fetch(`/cart/add.js`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        Selectors.updateMainProductProperty(mainGroupProductKey, redirectUrl);
        Selectors.loading(false);
      })
      .catch((error) => {
        Selectors.loading(false);
        // console.log("error", error);
        // if(target){
        //   const errorMsg = `Error: ${error}`;
        //   Selectors.showError(target, errorMsg);
        // }
      });
  },
  validate: function () {
    let validate = false;
    const errors = [];
    let firstError = null;

    document
      .querySelectorAll(this.classes.allProductsSelectors)
      .forEach((select) => {
        if (select.value == "") {
          Selectors.showError(select);
        } else {
          Selectors.removeError(select);
        }
      });
    document.querySelectorAll(this.classes.allProductsSelectors).forEach(select => {
      if (select.value == '') {
        Selectors.showError(select);
      } else {
        Selectors.removeError(select);
      }
    });

    if (document.querySelector('.product-option__item-input input') != null && document.querySelector('.product-option__item-input input').value == '') {
      Selectors.showError(document.querySelector('.product-option__item-input input'), '', '.product-option__item-input')
    } else {
      Selectors.removeError(document.querySelector('.product-option__item-input input'), '', '.product-option__item-input')
    }

    document.querySelectorAll(this.classes.requiredCheckboxSelect).forEach(checkbox => {
      if (checkbox.checked == false) {
        // console.log(this.classes.requiredCheckboxSelect, 'check')
        Selectors.showError(checkbox, '', '.product-options__checkbox-group-wrapper');
      } else {
        Selectors.removeError(checkbox, '.product-options__checkbox-group-wrapper');
      }
    });

    Selectors.validGroupOfCheckboxes();
    Selectors.validGroupOfChecked();

    document.querySelectorAll(this.classes.productOptionItemError).forEach(el => {
      errors.push(el)
    })
    document.querySelectorAll(this.classes.productCheckboxItemError).forEach(el => {
      errors.push(el)
    })
    document.querySelectorAll(this.classes.allPropertiesInputsError).forEach(el => {
      if(!el.classList.contains('product-form__properties')) {
        errors.push(el)
      }
    })

    if (errors.length > 0) {
      firstError = errors[0];
    } else {
      validate = true;
    }

    if (firstError) {
      Selectors.scrollToElement(firstError);
    }
    return validate;
  },
  showError: function (element, message, parentClass) {
    const parent = element.closest(
      parentClass ? parentClass : this.classes.productOptionItem
    );

    if(!parent.classList.contains('product-form__properties')) {
      parent.classList.add("error");
    }
    if (message) {
      parent.querySelector(".error-message").innerText = message;
      parent.querySelector(".error-message").classList.add("show");
    }
  },
  scrollToElement: function (target) {
    target.scrollIntoView({ behavior: "smooth", block: "center" });
  },
  removeError: function (element, parentClass) {
    if (!element) return
    const parent = element.closest(parentClass ? parentClass : this.classes.productOptionItem);
    const errorMessageBlock = parent != null ? parent.querySelector('.error-message') : '';

    if (parent != null) {
      parent.classList.remove('error');
    }
    if (errorMessageBlock) {
      parent.querySelector(".error-message").innerText = "";
      parent.querySelector(".error-message").classList.remove("show");
    }
  },
  validGroupOfCheckboxes: function () {
    document
      .querySelectorAll(this.classes.groupOfChecbxes)
      .forEach((checkbox) => {
        if ($(".group-of-checkboxes :checkbox:checked").length > 0) {
          $(".group-of-checkboxes").removeClass("error");
        } else {
          $(".group-of-checkboxes").addClass("error");
        }
      });
  },
  validGroupOfChecked: function () {
    document
      .querySelectorAll(this.classes.groupOfChecbxes)
      .forEach((checkbox) => {
        if ($(".group-of-checkboxes :checked").length > 0) {
          $(
            ".product-options__checkbox-group-wrapper.checkbox-logo"
          ).removeClass("error");
        } else {
          $(".product-options__checkbox-group-wrapper.checkbox-logo").addClass(
            "error"
          );
        }
      });
  },
  toggleVariants: function () {
    this.disableNoAvailableVariants();
    const variantSelectors = document.querySelectorAll(
      this.classes.variantButton
    );
    const defaultSelectorsWrapper = document.querySelectorAll(
      this.classes.defaultSelectorsWrapper
    );
    const then = this;

    variantSelectors.forEach((selector) => {
      selector.addEventListener("change", function (e) {
        const selectedValue =
          e.target.defaultValue || $(".select-variant option:selected").val();

        if (
          !selectedValue &&
          selectedValue == "undefined" &&
          !defaultSelectorsWrapper
        )
          return;
        defaultSelectorsWrapper.forEach((select) => {
          const currentSelector = select.querySelector("select");
          for (var option of currentSelector.options) {
            if (selectedValue === option.value) {
              currentSelector.value = option.value;
              // currentSelector.dispatchEvent(new Event("change"))
            }
          }
        });
        Selectors.toogleMainProductSelect();
        then.disableNoAvailableVariants();
      });
    });
  },
  toogleMainProductSelect: function (params) {
    const defaultVariantSelectors = document.querySelectorAll(
      this.classes.defaultSelectorsWrapper
    );
    const defaultProductFormSelector = document.querySelector(
      "select.product-form__variants"
    );
    const selectedValues = [];

    defaultVariantSelectors.forEach((selector) => {
      if (selector.querySelector("select").value) {
        selectedValues.push(selector.querySelector("select").value);
      }
    });
    for (let option of defaultProductFormSelector.options) {
      if (option.text.includes(" / ")) {
        // const buildedOptionValue = selectedValues.map( val => val).join(', ')
        // const options = option.text.split(', ');
        // const ArrayOfOptionValues = buildedOptionValue.split(', ')

        // if (selectedValues.every(value => value === ArrayOfOptionValues.filter(option => option === value)[0])) {
        //     defaultProductFormSelector.value = option.value
        //     defaultProductFormSelector.dispatchEvent(new Event("change"))
        // }
        const buildedOptionValue = selectedValues.map((val) => val).join(" / ");
        if (buildedOptionValue === option.text) {
          defaultProductFormSelector.value = option.value;
          defaultProductFormSelector.dispatchEvent(new Event("change"));
        }
      } else {
        if (selectedValues.every((value) => value === option.text)) {
          defaultProductFormSelector.value = option.value;
          defaultProductFormSelector.dispatchEvent(new Event("change"));
        }
      }
    }
  },

  disableNoAvailableVariants() {
    const availableVariants = [];

    const selectorAvailableVariants = document.querySelectorAll('select[name="id"] option');

    selectorAvailableVariants.forEach(option => {
      availableVariants.push(option.textContent.trim().split(" / "));
    })

    const variantsItemInputs = document.querySelectorAll(".product-form__controls-group-1 input");
    const variantItemOptions = document.querySelectorAll(".product-form__controls-group-1 option")

    // disable no available input item
    variantsItemInputs.forEach(input => {
      input.disabled = true;
    })

    variantItemOptions.forEach(option => {
      option.disabled = true;
    })

    if (variantsItemInputs.length > 0 && variantItemOptions.length === 0) {
      variantsItemInputs.forEach(input => {
        availableVariants.forEach(item => {
          if(item.includes(input.value)) {
            input.disabled = false;
          }
        })
      })
    }


    if (variantItemOptions.length > 0 && variantsItemInputs.length === 0) {
      variantItemOptions.forEach(option => {
        availableVariants.forEach(item => {
          if (item.includes(option.value)) {
            option.disabled = false;
          }
        })
      })
    }



    if (variantsItemInputs.length > 0 && variantItemOptions.length > 0) {
      const activeItemInput = [];
      const activeItemOption = [];

      variantsItemInputs.forEach(input => {
        if (input.checked) activeItemInput.push(input.value);
      })

      variantItemOptions.forEach(option => {
        if(option.selected) activeItemOption.push(option.value);
      })

      availableVariants.forEach(variant => {
        if(variant.includes(activeItemInput[0])) {
          variantItemOptions.forEach(option => {
            if(variant.includes(option.value)) {
              option.disabled = false
            }
          })
        }

        if(variant.includes(activeItemOption[0])) {
          variantsItemInputs.forEach(input => {
            if(variant.includes(input.value)) {
              input.disabled = false
            }
          })
        }
      })

    }
  },

  init: function () {
    // console.log("Init Product Selectors");
    this.clearInputs();
    this.toggleVariants();
    this.addToCartButton();
    this.onRelatedProductChange();
    this.onRelatedVariantChange();
    // this.onRelatedSingleProductPrice();
    this.onPropertieSelectChange();
    this.onPropertieInputChange();
    this.onPropertiesAreaChange();
    this.onSelectAdaptorModelChange();
    this.onPropertieRadioChange();
    this.onRequiredCheckboxChange();
    this.onProductCheckboxChange();
    this.calculateMultipleCheckboxes();
    this.onMultipleCheckboxChange();
    this.changePrice();
    this.onColorsChangeSlides();
    this.onRelatedVariantsChange();
    buildVariantsSwatches(".product-options__container");
  },
};
window.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
  Selectors.init();
});

$( document ).ready(function() {
$(".product-option__item-select").each(function(index){
    if ($(this).has('option:selected')){
        var currentSelectorVal = $(this).val();
      
     if ($(this).attr("name") != undefined){
       Selectors.propertiesObj = {
        ...Selectors.propertiesObj,
        [$(this).attr("name")]: currentSelectorVal,
      };
     }
      
    }
});
  var gripLogoInputVal = $("input[name='GRIP LOGO']:checked").val();
  Selectors.propertiesObj = {
        ...Selectors.propertiesObj,
        ['GRIP LOGO']: gripLogoInputVal,
      };
  Selectors.buildRelatedProductIds();
});